import React, { useContext, useState, useEffect, useRef } from 'react';
import { UserContext } from './UserContext'; // Importa il contesto
import TestataAdmin from "./partials/TestataAdmin";
import Footer from "./partials/Footer";
import Cuoricini from "./partials/Cuoricini";
import $ from 'jquery';
import 'datatables.net';
import { abbreviateName } from './utils';
function Dashboard() {
  const { userData } = useContext(UserContext); // Ottieni userData dal contesto
  const [utenti, setUtenti] = useState([]); // Stato per i documenti
  const [errorUtenti, setUtentiError] = useState(null);
  const [annunci, setAnnunci] = useState([]); // Stato per i documenti
  const [errorAnnunci, setAnnunciError] = useState(null);
  const [totUtenti, setTotUtenti] = useState(0);
  const [utentiAttivi, setUtentiAttivi] = useState(0);
  const [totAnnunci, setTotAnnunci] = useState(0);
  const [likes, setLikes] = useState(0);

  // Recupero ultimi Utenti registrati
  useEffect(() => {   
    const fetchUtenti = async () => {
      const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/utenti`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
            });

            if (response.ok) {
                const utenti = await response.json();
                setUtenti(utenti); // Aggiorna lo stato con i documenti ricevuti
            } else {
                throw new Error('Errore nel recupero degli Utenti');
            }
        } catch (err) {
            setUtentiError(err.message);
        }
    };

    fetchUtenti(); 
  }, []);// Chiama la funzione per recuperare gli Utenti   

  // Recupero ultimi fornitori
  useEffect(() => {   
    const fetchAnnunci = async () => {
      const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/annunciAdmin`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
            });

            if (response.ok) {
            const annunci = await response.json();
            setAnnunci(annunci); // Aggiorna lo stato con i documenti ricevuti
            } else {
            throw new Error('Errore nel recupero degli Annunci');
            }
        } catch (err) {
            setAnnunciError(err.message);
        }
    };

    fetchAnnunci(); 
  }, []);// Chiama la funzione per recuperare gli Operatori  

  

  // Recupero conteggi
  useEffect(() => {   
    const fetchUtenti = async () => {
      const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/totali`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
            });

            if (response.ok) {
                const data = await response.json();
                setTotUtenti(data.totUtenti);
                setUtentiAttivi(data.utentiAttivi);
                setTotAnnunci(data.totAnnunci);
            } else {
                throw new Error('Errore nel recupero degli Utenti');
            }
        } catch (err) {
            setUtentiError(err.message);
        }
    };

    fetchUtenti(); 
  }, []);// Chiama la funzione per recuperare gli Utenti  

    // Ref per l'elemento della tabella Utenti
  const tableUtentiRef = useRef(null);
  useEffect(() => {
    let tableUtenti;
    const initializeOrUpdateTable = () => {
      if (!$.fn.DataTable.isDataTable(tableUtentiRef.current)) {
        // Inizializza la DataTable solo se non è già stata inizializzata
        tableUtenti = $(tableUtentiRef.current).DataTable({ // Assegna il valore a table
            ordering: false,
            searching: true,
            paging: true,
            info: true,
            dom: "frtip",
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            language: {
            url: "/js/it-IT.json",
            },
            pageLength: 20,
        });
      }
    };

    // Verifica se tableUtentiRef.current è definito prima di inizializzare o aggiornare
    if (tableUtentiRef.current) {
        setTimeout(initializeOrUpdateTable, 500); // Timeout per garantire che il DOM sia pronto
    }

    // Distruggi la DataTable quando il componente viene smontato
    return () => {
        if (tableUtenti && tableUtenti.destroy) { // Controlla se table è definito e ha il metodo destroy
            tableUtenti.destroy();
            }
        };
    }, [utenti]);

  // Ref per l'elemento della tabella Annunci
  const tableAnnunciRef = useRef(null);
  useEffect(() => {
    let tableAnnunci;
    const initializeOrUpdateTableA = () => {
      if (!$.fn.DataTable.isDataTable(tableAnnunciRef.current)) {
        // Inizializza la DataTable solo se non è già stata inizializzata
        tableAnnunci = $(tableAnnunciRef.current).DataTable({ // Assegna il valore a table
            ordering: false,
            searching: true,
            paging: true,
            info: true,
            dom: "frtip",
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            language: {
            url: "/js/it-IT.json",
            },
            pageLength: 20,
        });
      }
    };

    // Verifica se tableAnnunciRef.current è definito prima di inizializzare o aggiornare
    if (tableAnnunciRef.current) {
        setTimeout(initializeOrUpdateTableA, 500); // Timeout per garantire che il DOM sia pronto
    }

    // Distruggi la DataTable quando il componente viene smontato
    return () => {
        if (tableAnnunci && tableAnnunci.destroy) { // Controlla se table è definito e ha il metodo destroy
            tableAnnunci.destroy();
            }
        };
    }, [utenti]);
    
  return (
    <>
        <section className="main_content dashboard_part">
            <div className="container-fluid g-0">
                <TestataAdmin userData={userData} />
            </div>
            <div className="main_content_iner ">
                <div className="container-fluid plr_30 body_white_bg pt_30">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-xl-4 col-sm-4 col-xs-12">
                            <div className="white_box mb_30 min_430" style={{border: '1px solid #b19dc9'}}>
                                <div className="box_header box_header_block">
                                    <div className="main-title" style={{whiteSpace: 'nowrap', width: '100%'}}>
                                        <h3 className="mb_0 text text-primary">Totale Agenzie registrate: </h3>
                                        <h1>{totUtenti}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4 col-xs-12">
                            <div className="white_box mb_30 min_430" style={{border: '1px solid #b19dc9'}}>
                                <div className="box_header box_header_block">
                                    <div className="main-title" style={{whiteSpace: 'nowrap', width: '100%'}}>
                                        <h3 className="mb_0 text text-primary">Totale Agenzie attive: </h3>
                                        <h1>{utentiAttivi}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-xl-4 col-sm-4 col-xs-12">
                            <div className="white_box mb_30 min_430" style={{border: '1px solid #b19dc9'}}>
                                <div className="box_header box_header_block">
                                    <div className="main-title" style={{whiteSpace: 'nowrap', width: '100%'}}>
                                        <h3 className="mb_0 text text-primary">Totale Annunci online: </h3>
                                        <h1>{totAnnunci}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-6 col-xl-6" style={{borderRight: '1px solid #b19dc9'}}>
                            <div className="white_box mb_30 min_430">
                                <div className="box_header box_header_block">
                                    <div className="main-title">
                                        <h3 className="mb-0">
                                            <a href="/amministratore/nuovo-utente" className='btn btn-sm btn-primary' style={{float: "right", marginLeft: "6px", fontSize: "0.66rem"}}><i className="ti ti-plus"></i> &nbsp; Nuovo</a>
                                            <a href="/amministratore/utenti" className="btn btn-sm btn-warning" style={{float: "right", fontSize: "0.66rem"}}><i className="ti ti-list"></i> &nbsp; Tutti</a>
                                            Ultime Agenzie registrate &nbsp; </h3>
                                    </div>
                                </div>
                                
                                {errorUtenti ? (
                                    <p>Errore: {errorUtenti}</p>
                                ) : (
                                    <div className="table-responsive">
                                        <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                                            <table className="table lms_table_active dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info" style={{width: '100%'}} ref={tableUtentiRef}>
                                                <thead>
                                                    <tr role="row">
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '40%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Ragione Sociale</th>
                                                        <th className="d-none d-sm-table-cell" scope="col" rowSpan="1" colSpan="1" style={{width: '26%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Nominativo</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '34%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>E-mail</th>
                                                    </tr>
                                                </thead>
                                                    <tbody>
                                                        {utenti.map((utente) => ( // Usare map per iterare sugli Operatori
                                                            <tr key={utente._id} role="row" className="odd"> 
                                                                <td> 
                                                                    <a href={`/amministratore/utente/${utente._id}`} title="Vedi anagrafica dettagliata" style={{color: utente.attivo != false ? '#b19DC9' : '#cf6969', fontWeight: '500', textDecoration: utente.attivo ? 'none' : 'line-through'}}>
                                                                    {utente.ragSociale || ""} 
                                                                    </a>
                                                                </td>
                                                               <td className="d-none d-sm-table-cell">{abbreviateName(utente.nome)}{utente.cognome}</td>
                                                               <td><a href={`mailto:${utente.mail}`} style={{color: '#b19DC9', fontWeight: '500'}}>{utente.mail}</a></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-6 col-xl-6">
                            <div className="white_box mb_30 min_430">
                                <div className="box_header box_header_block">
                                    <div className="main-title">
                                        <h3 className="mb-0"><a href="/amministratore/elenco-annunci" className="btn btn-sm btn-outline-primary" style={{float: "right", fontSize: "0.66rem"}}>Tutti</a>
                                        Ultimi Annunci inseriti &nbsp; </h3>
                                    </div>
                                </div>
                                
                                {errorAnnunci ? (
                                    <p>Errore: {errorAnnunci}</p>
                                ) : (
                                    <div className="table-responsive">
                                        <div id="DataTables_Table_1_wrapper" className="dataTables_wrapper no-footer">
                                            <table className="table lms_table_active dataTable no-footer dtr-inline" id="DataTables_Table_1" role="grid" aria-describedby="DataTables_Table_1_info" style={{width: '100%'}} ref={tableAnnunciRef}>
                                                <thead>
                                                    <tr role="row">
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '25%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Agenzia</th>
                                                        <th className="d-none d-sm-table-cell" scope="col" rowSpan="1" colSpan="1" style={{width: '30%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Nominativo</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '20%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Regione</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '25%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Comune</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '25%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Azioni</th>
                                                    </tr>
                                                </thead>
                                                    <tbody>
                                                        {annunci.map((annuncio) => ( // Usare map per iterare sugli Operatori
                                                            <tr key={annuncio._id} role="row" className="odd"> 
                                                                <td> 
                                                                    <a href={`/amministratore/utente/${annuncio.id_utente}`} title="Vedi anagrafica dettagliata" style={{color: annuncio.disattivo === true ? '#cf6969' : '#b19DC9', textDecoration: annuncio.disattivo === true ? 'line-through' : 'none', fontWeight: '500'}}>
                                                                    {annuncio.ragSociale || ""} 
                                                                    </a>
                                                                </td>
                                                               <td className="d-none d-sm-table-cell">
                                                                {annuncio.cuori > 0 && <Cuoricini likes={annuncio.cuori} />}{" "}
                                                                {abbreviateName(annuncio.nome)}{annuncio.cognome}</td>
                                                               <td>{annuncio.regione}</td>
                                                               <td>{annuncio.comune} ({annuncio.prov})</td>
                                                               <td><a href={`/amministratore/annuncio/${annuncio._id}`} className="btn btn-sm btn-primary" style={{float: "right", fontSize: "0.66rem"}}>Info</a></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                      <tr role="row">
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '25%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Agenzia</th>
                                                        <th className="d-none d-sm-table-cell" scope="col" rowSpan="1" colSpan="1" style={{width: '30%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Nominativo</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '20%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Regione</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '25%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Comune</th>
                                                        <th scope="col" rowSpan="1" colSpan="1" style={{width: '25%', fontSize: '0.8rem', fontWeight: '400', fontStyle: 'italic'}}>Azioni</th>
                                                      </tr>
                                                    </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                )}                                
                              </div>                             
                            </div>
                        </div>
                    </div>
                </div>
            
        <Footer />
      </section>
    </>
  );
}

export default Dashboard;